import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { GroupChildGraphTypeV1 } from "./groupChildGraphTypeV1";
import { Code, CodeDTO } from "../types/code";

export interface GroupChildGraphDetailsV1DTO {
  questionViewGraphType: GroupChildGraphTypeV1.GroupChildGraphTypeV1DTO;
  childQuestionCode: CodeDTO;
}

export class GroupChildGraphDetailsV1 {
  readonly isGroupChildGraphDetailsV1GroupChildGraphDetailsV1: boolean = true;

  readonly questionViewGraphType: GroupChildGraphTypeV1.GroupChildGraphTypeV1;
  readonly childQuestionCode: Code;


  constructor(
  questionViewGraphType: GroupChildGraphTypeV1.GroupChildGraphTypeV1, 
  childQuestionCode: Code
  ) {
    this.questionViewGraphType = questionViewGraphType;
    this.childQuestionCode = childQuestionCode;
  }

  static fromDTO(dto: GroupChildGraphDetailsV1DTO): GroupChildGraphDetailsV1 {
    const questionViewGraphType = GroupChildGraphTypeV1.fromDTO(getObject(dto, "questionViewGraphType", InvalidGroupChildGraphDetailsV1QuestionViewGraphTypeError));
    const childQuestionCode = Code.fromDTO(getObject(dto, "childQuestionCode", InvalidGroupChildGraphDetailsV1ChildQuestionCodeError));
    return new GroupChildGraphDetailsV1(
      questionViewGraphType,
      childQuestionCode
    );
  }

  toDTO(): GroupChildGraphDetailsV1DTO {
    const dto: GroupChildGraphDetailsV1DTO = {
        questionViewGraphType: this.questionViewGraphType.toDTO(),
        childQuestionCode: this.childQuestionCode.toDTO()
    };
    return dto;
  }
  }

GroupChildGraphDetailsV1.prototype.toString = function toString(): string {
  return `GroupChildGraphDetailsV1(questionViewGraphType='${this.questionViewGraphType}',childQuestionCode='${this.childQuestionCode}')`;
};

export class InvalidGroupChildGraphDetailsV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphDetailsV1Error";
  }
}
export class InvalidGroupChildGraphDetailsV1QuestionViewGraphTypeError extends InvalidGroupChildGraphDetailsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphDetailsV1QuestionViewGraphTypeError";
  }
}

export class InvalidGroupChildGraphDetailsV1ChildQuestionCodeError extends InvalidGroupChildGraphDetailsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphDetailsV1ChildQuestionCodeError";
  }
}
